import React, { useState } from 'react';
import { Offcanvas, Form, Button, InputGroup, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Flatpickr from 'react-flatpickr';

const FilterTimesheetsOffcanvas = ({ show, onHide, onSubmit, filters }) => {
    const [localFilters, setLocalFilters] = useState(filters);
    const [dueDateRange, setDueDateRange] = useState([null, null]);

    // Sample data - replace with actual data from your backend
    const projectOptions = [
        { value: 'project1', label: 'Project 1' },
        { value: 'project2', label: 'Project 2' },
        { value: 'project3', label: 'Project 3' },
    ];

    const taskOptions = [
        { value: 'task1', label: 'Task 1' },
        { value: 'task2', label: 'Task 2' },
        { value: 'task3', label: 'Task 3' },
    ];

    const assigneeOptions = [
        { value: 'user1', label: 'John Doe' },
        { value: 'user2', label: 'Jane Smith' },
        { value: 'user3', label: 'Bob Johnson' },
    ];

    const priorityOptions = [
        { value: 'high', label: 'High' },
        { value: 'medium', label: 'Medium' },
        { value: 'low', label: 'Low' },
    ];

    const stageOptions = [
        { value: 'planning', label: 'Planning' },
        { value: 'development', label: 'Development' },
        { value: 'review', label: 'Review' },
        { value: 'testing', label: 'Testing' },
        { value: 'completed', label: 'Completed' },
    ];

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(localFilters);
    };

    const handleReset = () => {
        setLocalFilters({
            taskName: '',
            project: null,
            tasks: [],
            assignees: [],
            startDate: null,
            endDate: null,
            dueStartDate: null,
            dueEndDate: null,
            priority: null,
            stage: null,
            status: []
        });
    };

    // Reset local filters when offcanvas is shown
    React.useEffect(() => {
        if (show) {
            setLocalFilters(filters);
        }
    }, [show, filters]);

    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header className='px-4 py-3' closeButton>
                <Offcanvas.Title className='display-1'>Filter Timesheets</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className='px-4 py-3'>
                <Form onSubmit={handleSubmit}>
                    <Row className='gy-2'>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Task Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={localFilters.taskName || ''}
                                    onChange={(e) => setLocalFilters({
                                        ...localFilters,
                                        taskName: e.target.value
                                    })}
                                    placeholder=""
                                />
                            </Form.Group>
                        </Col>

                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Project</Form.Label>
                                <Select
                                    value={localFilters.project}
                                    onChange={(value) => setLocalFilters({
                                        ...localFilters,
                                        project: value
                                    })}
                                    options={projectOptions}
                                    isClearable
                                    placeholder=""
                                />
                            </Form.Group>
                        </Col>

                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Task List</Form.Label>
                                <Select
                                    isMulti
                                    value={localFilters.tasks}
                                    onChange={(value) => setLocalFilters({
                                        ...localFilters,
                                        tasks: value
                                    })}
                                    options={taskOptions}
                                    placeholder=""
                                />
                            </Form.Group>
                        </Col>

                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Assignees</Form.Label>
                                <Select
                                    isMulti
                                    value={localFilters.assignees}
                                    onChange={(value) => setLocalFilters({
                                        ...localFilters,
                                        assignees: value
                                    })}
                                    options={assigneeOptions}
                                    placeholder=""
                                />
                            </Form.Group>
                        </Col>

                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Due Date Range</Form.Label>
                                <InputGroup>
                                    <Flatpickr
                                        value={dueDateRange[0]}
                                        onChange={([date]) => setDueDateRange([date, dueDateRange[1]])}
                                        className="form-control"
                                        options={{
                                            dateFormat: 'd M Y',
                                            maxDate: dueDateRange[1] || 'today',
                                            allowInput: true,
                                            disableMobile: true,
                                            enableTime: false,
                                        }}
                                        placeholder="Start date"
                                    />
                                    <InputGroup.Text className="bg-light p-tag">to</InputGroup.Text>
                                    <Flatpickr
                                        value={dueDateRange[1]}
                                        onChange={([date]) => setDueDateRange([dueDateRange[0], date])}
                                        className="form-control"
                                        options={{
                                            dateFormat: 'd M Y',
                                            maxDate: 'today',
                                            minDate: dueDateRange[0],
                                            allowInput: true,
                                            disableMobile: true,
                                            enableTime: false,
                                        }}
                                        placeholder="End date"
                                    />
                                </InputGroup>
                            </Form.Group>
                        </Col>

                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Priority</Form.Label>
                                <Select
                                    value={localFilters.priority}
                                    onChange={(value) => setLocalFilters({
                                        ...localFilters,
                                        priority: value
                                    })}
                                    options={priorityOptions}
                                    isClearable
                                    placeholder=""
                                />
                            </Form.Group>
                        </Col>

                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Stage</Form.Label>
                                <Select
                                    value={localFilters.stage}
                                    onChange={(value) => setLocalFilters({
                                        ...localFilters,
                                        stage: value
                                    })}
                                    options={stageOptions}
                                    isClearable
                                    placeholder=""
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Offcanvas.Body>
            <div className="py-3 px-4 border-top">
                <div className="d-flex justify-content-between">
                    <Button variant="link" className='text-decoration-none'>
                        Reset
                    </Button>
                    <Button variant="primary" onClick={onHide}>
                        Apply Filters
                    </Button>
                </div>
            </div>
        </Offcanvas>
    );
};

FilterTimesheetsOffcanvas.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    filters: PropTypes.shape({
        taskName: PropTypes.string,
        project: PropTypes.object,
        tasks: PropTypes.arrayOf(PropTypes.object),
        assignees: PropTypes.arrayOf(PropTypes.object),
        startDate: PropTypes.instanceOf(Date),
        endDate: PropTypes.instanceOf(Date),
        dueStartDate: PropTypes.instanceOf(Date),
        dueEndDate: PropTypes.instanceOf(Date),
        priority: PropTypes.object,
        stage: PropTypes.object,
        status: PropTypes.arrayOf(PropTypes.string)
    }).isRequired
};

export default FilterTimesheetsOffcanvas;
